import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EvaluationInterface } from 'app/assessment/evaluation/models';
import {
  AddEvaluationRecommendations,
  AddNewReviewComment,
  DeleteReviewComment,
  LoadCurrentEvaluation,
  LoadEvaluations,
  RemoveEvaluationRecommendations,
  UpdateCurrentEvaluation,
  UpdateCurrentEvaluationRelatedTaskCompleted,
  UpdateEvaluationRecommendations,
  UpdateEvaluationRecommendationsAll,
  UpdateReviewComment,
} from 'app/assessment/evaluation/state/actions';
import { ReviewInterface } from 'app/assessment/models/review.model';
import { AppStateInterface } from 'app/core/app-config/state/models/app-state.interface';
import { RecommendationInterface } from 'app/recommendation/models';
import { TaskInterface } from 'app/task/models';
import { Observable } from 'rxjs/internal/Observable';

import { EvaluationServiceInterface } from './evaluation-service.interface';

@Injectable()
export class EvaluationService implements EvaluationServiceInterface {

  constructor(private readonly _store: Store<AppStateInterface>) {}

  public getEvaluationById(id: number): Observable<Readonly<EvaluationInterface>> {
    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.evaluations[id]);
  }

  public getSelectedEvaluation(): Observable<Readonly<number>> {

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.selectedEvaluation);
  }

  public getEvaluations(userId: number): Observable<Readonly<{ [id: number]: EvaluationInterface }>> {
    this._store.dispatch(new LoadEvaluations(userId));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.evaluations);
  }

  public updateEvaluation(evaluation: EvaluationInterface): Observable<EvaluationInterface> {
    throw new Error('Method not implemented.');
  }

  public getCurrentEvaluation(userId: number, evaluationId?: number, loadData: boolean = true): Observable<Readonly<EvaluationInterface>> {

    if (loadData) {
      const payload: {userId: number, evaluationId?: number} = { userId, evaluationId };
      this._store.dispatch(new LoadCurrentEvaluation(payload));
    }

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public updateCurrentEvaluation(evaluation: EvaluationInterface): Observable<EvaluationInterface> {
    this._store.dispatch(new UpdateCurrentEvaluation(evaluation));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public addNewReviewComment(data: {text: string, userId: number, evalId: number}): Observable<EvaluationInterface> {
    const payload: {text: string, userId: number, evalId: number} = data;
    this._store.dispatch(new AddNewReviewComment(payload));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public updateReviewComment(data: {review: ReviewInterface, userId: number, evalId: number}): Observable<EvaluationInterface> {
    const payload: {review: ReviewInterface, userId: number, evalId: number} = data;
    this._store.dispatch(new UpdateReviewComment(payload));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public deleteReviewComment(data: {review: ReviewInterface, userId: number, evalId: number}): Observable<EvaluationInterface> {
    const payload: {review: ReviewInterface, userId: number, evalId: number} = data;
    this._store.dispatch(new DeleteReviewComment(payload));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public addRecommendation(
    evaluation: EvaluationInterface,
    recommendation: RecommendationInterface): Observable<EvaluationInterface> {
    this._store.dispatch(new AddEvaluationRecommendations({ evaluation, recommendation }));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public updateRecommendations(recommendation: RecommendationInterface): Observable<EvaluationInterface> {
    this._store.dispatch(new UpdateEvaluationRecommendations(recommendation));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }
  public updateRecommendationsAll(recommendation: RecommendationInterface[]): Observable<EvaluationInterface> {
    this._store.dispatch(new UpdateEvaluationRecommendationsAll(recommendation));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }


  public removeRecommendations(recommendation: RecommendationInterface): Observable<EvaluationInterface> {
    this._store.dispatch(new RemoveEvaluationRecommendations(recommendation));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluation);
  }

  public updateCurrentEvaluationRelatedTask(task: TaskInterface): Observable<Readonly<TaskInterface>> {
    this._store.dispatch(new UpdateCurrentEvaluationRelatedTaskCompleted(task));

    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluationRelatedTask);
  }

  public getCurrentEvaluationRelatedTask(): Observable<Readonly<TaskInterface>> {
    return this._store.select(({ evaluation }: AppStateInterface) => evaluation.currentEvaluationRelatedTask);
  }
}
